import { Observable } from 'rxjs';
import { IGetGateway } from '../../gateways';
import { CITIES_SCHEMA, ICity, ICityListRequest } from '@web/dtos';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import { RestCallBuilder } from '../../../../builder/rest/rest-call.builder';
import { AppConfigService } from '../../../app-config.service';
import { inject } from '@angular/core';

export class CityGateway implements IGetGateway<
  ICityListRequest,
  IApiResponse<ICity[]>
> {
  private readonly configService: AppConfigService = inject(AppConfigService);
  private readonly restCallBuilder: RestCallBuilder<ICity[]> =
    new RestCallBuilder<ICity[]>([]);

  get(request: ICityListRequest): Observable<IApiResponse<ICity[]>> {
    return this.restCallBuilder
      .getExternal(
        `${this.configService.get().general.addressValidationUrl}/cities/`,
        { ...request }
      )
      .validate(API_RESPONSE_SCHEMA(CITIES_SCHEMA), 'City.get')
      .handleMessages()
      .build();
  }
}
